var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7356 8.09384L0.132529 2.30473C0.0524266 2.22211 0.012207 2.12682 0.012207 2.01913C0.012207 1.91157 0.0524266 1.81642 0.132529 1.73361L0.733716 1.11242C0.813861 1.02962 0.905923 0.988281 1.01028 0.988281C1.11464 0.988281 1.20671 1.02962 1.28685 1.11242L6.01229 5.99459L10.7379 1.11246C10.818 1.02966 10.9102 0.988325 11.0143 0.988325C11.1186 0.988325 11.2108 1.02966 11.291 1.11246L11.892 1.73366C11.9722 1.81642 12.0122 1.91157 12.0122 2.01917C12.0122 2.12699 11.9722 2.22215 11.892 2.30473L6.2889 8.09384C6.2088 8.1766 6.11652 8.21789 6.01233 8.21789C5.90814 8.21789 5.81591 8.1766 5.7356 8.09384Z",
    fill: "#8A8A8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.29434b4ff0e54b905ec9ffa882e503f5.svg";
export { ForwardRef as ReactComponent };